// extracted by mini-css-extract-plugin
export default {"primaryColor":"#14397f","secondaryColor":"#fff","complementaryColor":"#2aa8e0"};